import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Button, Form, Badge } from 'react-bootstrap';
import API from '../services/api';

// Admins: the company's bank accounts that a transfer can be received in. Accounts are switched off, never
// deleted, so payments recorded against them keep reading correctly.
const BankAccountsModal = ({ onClose }) => {
  const [accounts, setAccounts] = useState(null);
  const [name, setName] = useState('');
  const [editing, setEditing] = useState(null); // { id, name }
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => API.get('/bank-accounts?all=1')
    .then(r => setAccounts(r.data))
    .catch(err => setError(err.response?.data?.message || 'No se pudieron cargar las cuentas.')), []);
  useEffect(() => { load(); }, [load]);

  const run = async (fn) => {
    setBusy(true); setError('');
    try { await fn(); await load(); } catch (err) { setError(err.response?.data?.message || 'La acción falló.'); } finally { setBusy(false); }
  };

  const add = () => run(async () => { await API.post('/bank-accounts', { name }); setName(''); });
  const toggle = (a) => run(() => API.put(`/bank-accounts/${a._id}`, { active: !a.active }));
  const rename = () => run(async () => { await API.put(`/bank-accounts/${editing.id}`, { name: editing.name }); setEditing(null); });

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton><Modal.Title>Cuentas bancarias</Modal.Title></Modal.Header>
      <Modal.Body>
        <div className="small text-muted mb-3">Las cuentas donde recibes transferencias. Se elige una al registrar un cobro por transferencia. Una cuenta desactivada ya no aparece para elegir, pero los cobros anteriores la conservan.</div>
        {accounts === null ? <div className="text-muted">Cargando...</div> : accounts.length === 0 ? <div className="text-muted mb-3">Todavía no hay cuentas.</div> : (
          <div className="mb-3">
            {accounts.map(a => (
              <div key={a._id} className="d-flex align-items-center gap-2 py-2" style={{ borderTop: '1px solid var(--mm-line)' }}>
                {editing?.id === a._id ? (
                  <>
                    <Form.Control size="sm" autoFocus maxLength={80} value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })}
                      onKeyDown={e => { if (e.key === 'Enter' && editing.name.trim()) rename(); if (e.key === 'Escape') setEditing(null); }} />
                    <Button size="sm" variant="primary" disabled={busy || !editing.name.trim()} onClick={rename}>Guardar</Button>
                    <Button size="sm" variant="outline-secondary" onClick={() => setEditing(null)}>Cancelar</Button>
                  </>
                ) : (
                  <>
                    <div style={{ flex: 1, minWidth: 0, opacity: a.active ? 1 : 0.6 }}>{a.name} {!a.active && <Badge bg="secondary">Desactivada</Badge>}</div>
                    <Button size="sm" variant="outline-secondary" title="Renombrar" onClick={() => setEditing({ id: a._id, name: a.name })}><i className="bi bi-pencil" /></Button>
                    <Button size="sm" variant={a.active ? 'outline-secondary' : 'outline-primary'} disabled={busy} onClick={() => toggle(a)}>{a.active ? 'Desactivar' : 'Activar'}</Button>
                  </>
                )}
              </div>
            ))}
          </div>
        )}
        <Form.Label className="small text-muted mb-1">Agregar una cuenta</Form.Label>
        <div className="d-flex gap-2">
          <Form.Control maxLength={80} placeholder="Ej.: Banco Popular · Corriente 1234" value={name} onChange={e => setName(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' && name.trim()) { e.preventDefault(); add(); } }} />
          <Button variant="primary" className="flex-shrink-0" disabled={busy || !name.trim()} onClick={add}>Agregar</Button>
        </div>
        {error && <div className="alert alert-danger mt-3 mb-0">{error}</div>}
      </Modal.Body>
      <Modal.Footer><Button variant="outline-secondary" onClick={onClose}>Cerrar</Button></Modal.Footer>
    </Modal>
  );
};

export default BankAccountsModal;
